// extracted by mini-css-extract-plugin
var _1 = "MTUfL";
var _2 = "_2TRc";
var _3 = "eqyeX";
var _4 = "zDhG5";
var _5 = "OxmhU";
var _6 = "a49gT";
var _7 = "M2Rtm";
var _8 = "vrJnS";
var _9 = "ygo_d";
var _a = "YEIpE";
var _b = "hiAEE";
var _c = "iv55U";
var _d = "u_CGW";
var _e = "aULr3";
var _f = "p73nv";
export { _1 as "aqua", _2 as "dark", _3 as "darkest", _4 as "gold", _5 as "light", _6 as "lightest", _7 as "marker", _8 as "mint", _9 as "neutral", _a as "normal", _b as "overflow-multiline", _c as "overflow-singleline", _d as "ruby", _e as "teal", _f as "violet" }
